import React, { useEffect, useState } from 'react';

import SvgInfo from '..//svg/Info';
import SvgSafety from '../svg/Safety';
import SvgPlant from '../svg/Plant';
import './Informations.css';
import { useSelector } from 'react-redux';
import { translate } from '../i18n';
import { RootState } from '../store';
import axios from '../api/axios';
import { ERepositoryPage, IPhoto as IPicture } from './types';
import { useParams } from 'react-router-dom';
import useWindowDimensions from '../utils/WindowDimensions';
import { info } from 'console';

interface IInformationsPageProps {}

const InformationsPage: React.FC<IInformationsPageProps> = (props) => {
    const [information, setInformation] = useState<IPicture>();
    const [durability, setDurability] = useState<IPicture>();
    const [certification, setCertification] = useState<IPicture>();
    const [activeTab, setActiveTab] = useState<IPicture>();
    const { height, width } = useWindowDimensions();

    const { language } = useSelector((state: RootState) => state.lang);
    const params = useParams();
    const buildingId = params.buildingId;

    const GET_IMAGES_URL = '/api/hblogin/repository/GetImagesByBuildingId';

    useEffect(() => {
        axios.get<IPicture[]>(`${GET_IMAGES_URL}`, { params: { id: buildingId } }).then((response) => {
            let durability = response.data.filter((photo) => photo.repositoryPage === ERepositoryPage.durability)[0];
            let information = response.data.filter((photo) => photo.repositoryPage === ERepositoryPage.information)[0];
            let certification = response.data.filter((photo) => photo.repositoryPage === ERepositoryPage.certification)[0];

            setActiveTab(information);
            setInformation(information);
            setDurability(durability);
            setCertification(certification);
        });
    }, []);

    const setImageSource = () => {
        if (language === 'EN' && width > height) return activeTab?.urlEnglishHorizontal;
        if (language === 'EN' && width <= height) return activeTab?.urlEnglishVertical;
        if (language === 'FR' && width > height) return activeTab?.urlFrenchHorizontal;
        if (language === 'FR' && width <= height) return activeTab?.urlFrenchVertical;
    };

    const activeColor = '#FFFFFF';
    const innactiveColor = '#424559';

    return (
        <div className="Info">
            <div className="Info-Top ">
                <img id="InfoImg" src={setImageSource()} width="86.71vw" height="69.44vh" alt="Information" />
            </div>
            <div className="Info-Bottom">
                <button
                    className={activeTab?.repositoryPage === ERepositoryPage.information ? 'Info-About Info-Tab active Drop-Shadow ' : 'Info-About Info-Tab Drop-Shadow'}
                    onClick={() => setActiveTab(information)}
                >
                    <div className="Info-Tab-Icon">
                        <SvgInfo width={'100%'} height={'100%'} color={activeTab?.repositoryPage === ERepositoryPage.information ? activeColor : innactiveColor} />
                    </div>
                    <div className="Info-Tab-Text">{translate('About', language)}</div>
                </button>
                <button
                    className={activeTab?.repositoryPage === ERepositoryPage.durability ? 'Info-Eco Info-Tab Drop-Shadow active' : 'Info-Eco Info-Tab Drop-Shadow'}
                    onClick={() => setActiveTab(durability)}
                >
                    <div className="Info-Tab-Icon">
                        <SvgPlant width={'100%'} height={'100%'} color={activeTab?.repositoryPage === ERepositoryPage.durability ? activeColor : innactiveColor} />
                    </div>
                    <div className="Info-Tab-Text">{translate('Durability', language)}</div>
                </button>
                <button
                    className={activeTab?.repositoryPage === ERepositoryPage.certification ? 'Info-Cert Info-Tab Drop-Shadow active' : 'Info-Cert Info-Tab Drop-Shadow'}
                    onClick={() => setActiveTab(certification)}
                >
                    <div className="Info-Tab-Icon">
                        <SvgSafety width={'100%'} height={'100%'} color={activeTab?.repositoryPage === ERepositoryPage.certification ? activeColor : innactiveColor} />
                    </div>
                    <div className="Info-Tab-Text">{translate('Certifications', language)}</div>
                </button>
            </div>
        </div>
    );
};

export default InformationsPage;
